export enum ExpirationBillEnum {
    BLACK_WARNING = 0,
    RED_WARNING = 1,
    YELLOW_WARNING = 2,
    GREEN_WARNING = 3,
};

export enum ExpirationDriverPaymentEnum {
    BLACK_WARNING = 0,
    RED_WARNING = 1,
    YELLOW_WARNING = 2,
    GREEN_WARNING = 3,
};
